import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OutingIterationService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getById(id: string): any {
    return this.http.get(`${this.url}/outingiteration/${id}`);
  }

  update(data): any{
    return this.http.post(`${this.url}/outingiteration/update`, data);
  }

}
